import { createSlice } from '@reduxjs/toolkit';

const loadEventFromSession = () => {
  try {
    const eventData = sessionStorage.getItem('yk_event_booking');
    if (eventData) {
      return JSON.parse(eventData);
    }
  } catch (error) {
    console.error('Error loading event from session:', error);
  }
  // Default to USA and Atlanta center
  return {
    selectedCountry: {
      id: 1,
      name: 'USA',
      entityCount: 0,
      organizationId: 3
    },
    selectedCenter: {
      center_Id: 2,
      center_Name: 'Atlanta',
      center_Logo_URL: 'https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png',
      center_Desc: 'Yugal Kunj Atlanta',
      organization_Id: 3,
      app_Id: 1
    },
    selectedEvent: null,
    selectedSeva: null,
    selectedTiming: null,
    registrationData: null,
    familyMembers: [],
  };
};

const initialState = loadEventFromSession();

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload;
      sessionStorage.setItem('yk_event_booking', JSON.stringify(state));
    },
    setSelectedCenter: (state, action) => {
      state.selectedCenter = action.payload;
      sessionStorage.setItem('yk_event_booking', JSON.stringify(state));
    },
    setSelectedEvent: (state, action) => {
      state.selectedEvent = action.payload;
      sessionStorage.setItem('yk_event_booking', JSON.stringify(state));
    },
    setSelectedSeva: (state, action) => {
      state.selectedSeva = action.payload;
      sessionStorage.setItem('yk_event_booking', JSON.stringify(state));
    },
    setSelectedTiming: (state, action) => {
      state.selectedTiming = action.payload;
      sessionStorage.setItem('yk_event_booking', JSON.stringify(state));
    },
    setRegistrationData: (state, action) => {
      state.registrationData = action.payload;
      sessionStorage.setItem('yk_event_booking', JSON.stringify(state));
    },
    setFamilyMembers: (state, action) => {
      state.familyMembers = action.payload;
      sessionStorage.setItem('yk_event_booking', JSON.stringify(state));
    },
    addFamilyMember: (state, action) => {
      state.familyMembers.push(action.payload);
      sessionStorage.setItem('yk_event_booking', JSON.stringify(state));
    },
    removeFamilyMember: (state, action) => {
      state.familyMembers = state.familyMembers.filter((_, index) => index !== action.payload);
      sessionStorage.setItem('yk_event_booking', JSON.stringify(state));
    },
    clearEventData: (state) => {
      state.selectedCountry = null;
      state.selectedCenter = null;
      state.selectedEvent = null;
      state.selectedSeva = null;
      state.selectedTiming = null;
      state.registrationData = null;
      state.familyMembers = [];
      sessionStorage.removeItem('yk_event_booking');
    },
  },
});

export const {
  setSelectedCountry,
  setSelectedCenter,
  setSelectedEvent,
  setSelectedSeva,
  setSelectedTiming,
  setRegistrationData,
  setFamilyMembers,
  addFamilyMember,
  removeFamilyMember,
  clearEventData,
} = eventSlice.actions;

export default eventSlice.reducer;
